import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
  apiKey: "AIzaSyCRUL3YS1KWDAwmwfHFQaff_oleeoVgdLg",
  authDomain: "buildmytravel-db1.firebaseapp.com",
  projectId: "buildmytravel-db1",
  storageBucket: "buildmytravel-db1.appspot.com",
  messagingSenderId: "632439714376",
  appId: "1:632439714376:web:692b9d79238e0d619d9e7d",
  measurementId: "G-XRG9Q78WHT",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
